import View from './views/View'

const route = {
    exact: true,
    purePath: '/contact',
    path: '/:lang/contact',
    component: View
}

export default route